import routes from "../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPut} from "../../../../core/services/common/HttpRequestBuilder"


const getEIDListByUser = (user_uid) => {
    let query_params = {
        user_uid,
    }
    let result = HttpAuthGet(routes.GET_LIST_EID_BY_USER, query_params);
    return result;
}

const generateEID = (profile_uid) => {
    let query_params = {
        profile_uid,
    }
    let result = HttpAuthGet(routes.GENERATE_EID, query_params);
    return result;
}

const viewEID = (profile_uid) => {
    let query_params = {
        profile_uid,
    }
    let result = HttpAuthGet(routes.VIEW_EID, query_params);
    return result;
}

const getEIDInfoQRCode = () => {
    let result = HttpAuthGet(routes.GET_EID_INFO_QRCODE);
    return result;
}

const shareEID = (fields) => {
    let payload = {
        fields,
    }
    let result = HttpAuthPost(routes.SHARE_EID, payload);
    return result;
}

const updateEIDStatus = (uuid, status) => {
    let payload = {
        uuid,
        status,
    }
    let result = HttpAuthPut(routes.CHANGE_EID_STATUS, payload);
    return result;
}

const EIDService = {
    getEIDListByUser,
    generateEID,
    viewEID, 
    getEIDInfoQRCode,
    shareEID, 
    updateEIDStatus
}

export default EIDService
